var _ellipse, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2449,
    cy: 3.42857,
    rx: 3.42857,
    ry: 3.42857,
    fill: "#FFFF00"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7152 20.6751C19.5982 19.4591 20.1143 17.9901 20.1143 16.4082C20.1143 12.2153 16.4887 8.81631 12.0164 8.81631C7.54398 8.81631 3.9184 12.2153 3.9184 16.4082C3.9184 17.9901 4.43452 19.4591 5.31751 20.6751H18.7152Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7152 20.6751V22.6751H19.7346L20.3336 21.8502L18.7152 20.6751ZM5.31751 20.6751L3.69916 21.8502L4.29812 22.6751H5.31751V20.6751ZM18.1143 16.4082C18.1143 17.5451 17.7455 18.6066 17.0969 19.4999L20.3336 21.8502C21.4509 20.3115 22.1143 18.4351 22.1143 16.4082H18.1143ZM12.0164 10.8163C15.5077 10.8163 18.1143 13.4395 18.1143 16.4082H22.1143C22.1143 10.9911 17.4698 6.81631 12.0164 6.81631V10.8163ZM5.9184 16.4082C5.9184 13.4395 8.52499 10.8163 12.0164 10.8163V6.81631C6.56296 6.81631 1.9184 10.9911 1.9184 16.4082H5.9184ZM6.93586 19.4999C6.28718 18.6066 5.9184 17.5451 5.9184 16.4082H1.9184C1.9184 18.4351 2.58185 20.3115 3.69916 21.8502L6.93586 19.4999ZM5.31751 22.6751H18.7152V18.6751H5.31751V22.6751Z",
    fill: "white",
    mask: "url(#path-2-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7686995c.svg";
export { ForwardRef as ReactComponent };